import * as ApiRequests from '../../api/requests';
import { AuthHelper } from '../../types/auth-helper-types';
import { AppThunk } from '../actions';
import { PxdbDeviceActions} from '../actions/pxdb-device-actions';

export const PxdbDeviceThunks = {
    PxdbDeviceRegistration: (
        pxgatewayDeviceData: {  
                name: string;
                serial: string;
                deviceId: string;
                siteId: string;
                deviceProfileID: string;
            },
            authHelper: AuthHelper,
            addToast: Function    
    ): AppThunk => async (dispatch): Promise<void> => {
        dispatch(PxdbDeviceActions.pxdbGatewayDeviceRegistrationStarted());

        const payload = await ApiRequests.createPXGatewayDevice(
            {
                name: pxgatewayDeviceData.name,
                serial: pxgatewayDeviceData.serial,
                deviceId: pxgatewayDeviceData.deviceId,
                siteId: pxgatewayDeviceData.siteId,
                deviceProfileID: pxgatewayDeviceData.deviceProfileID,
            },
            { authHelper }
        );
        if (payload.ok) {
            dispatch(
                PxdbDeviceActions.pxdbGatewayDeviceRegistrationSucceeded(
                    payload.response.message,
                    payload.response.data,
                    payload.response.data.connectionString
                )
            );
        } else {
            const errorCode = ApiRequests.extractResponseNotOkCode(payload.response);
           
            addToast(ApiRequests.extractResponseNotOkMessage(payload.response), 'error');    
            if (errorCode === 4001 ){ 
                addToast(ApiRequests.extractResponseNotOkMessage(payload.response), 'error');
            }    
            dispatch(PxdbDeviceActions.pxdbGatewayDeviceRegistrationFailed(errorCode.toString()));
        }
    },
    
 
};
